import isMobile from '$/utils/isMobile';
import type { ActionsPaneDimensions, WebinarDimensions } from './context';

const windowArea = {
  width: typeof window === 'undefined' ? 0 : window.innerWidth,
  height: typeof window === 'undefined' ? 0 : window.innerHeight,
};

const actionsPane: ActionsPaneDimensions = {
  location: 'none',
  marginTopPx: 0,
  pinnedCard: {
    height: isMobile ? 35 : 50,
    scale: 1,
    radius: 10,
  },
  icard: {
    widthRem: isMobile ? 10 : 25,
    mediaTitleHeightPx: 154,
    mediaTitleRatio: 155 / 300,
    titleHeightPx: 55,

    paddingLeftRem: isMobile ? 0.25 : 1,
    inactivityTimeoutSecs: 10,
    marginYpx: 14,
    modalPreviewWidth: 29,

    compressed: {
      pageHeight: 77 * 3,
      cardHeight: 77,
      marginY: 14,
      parallax: 75,
    },
    expanded: {
      mediaTitleHeightPx: 154,
      titleHeight: 45,
      duration: 0.25,
    },
  },

  idock: {
    top: 75,
    iconsTop: 0,
    widthRem: 4,
    paddingLeftRem: 3,
    paddingRightRem: 0.5,
  },

  actionsTopPx: 0,
  actionsXPx: 0,
  snappedCardTopPx: 80,
  whiteOutHeightRem: 8,
  heightPx: 0,
  rightWidthRem: 0,
  maxWidthRem: 0,
  bottomWidthRem: 0,
};
actionsPane.maxWidthRem =
  actionsPane.idock.widthRem +
  actionsPane.idock.paddingLeftRem +
  actionsPane.icard.widthRem +
  actionsPane.icard.paddingLeftRem;
actionsPane.bottomWidthRem = actionsPane.maxWidthRem;
actionsPane.rightWidthRem = actionsPane.maxWidthRem;

const videoControlsArea = {
  height: windowArea.height,
  width: windowArea.width,
  portraitRatio: 0.5, // How much space to allocate for video on portrait device

  topBar: {
    height: isMobile ? actionsPane.pinnedCard.height : actionsPane.pinnedCard.height + 10,
  },

  bottomBar: {
    paddingY: isMobile ? 6 : 10,
    paddingX: isMobile ? 14 : 28,
    height: isMobile ? 42 + 2 * 4 : 42 + 2 * 10,
  },
};

const videoArea = {
  top: 0,
  width: videoControlsArea.width,
  height: videoControlsArea.height - videoControlsArea.bottomBar.height, // Assume bottom bar is out of video
  aspectRatio:
    videoControlsArea.width / (videoControlsArea.height - videoControlsArea.bottomBar.height),
};

const roomArea = videoArea;
roomArea.height = videoControlsArea.height;

const video = {
  width: 1024,
  height: 768,
  aspectRatio: 1.7777777778,
};

export const staticWebinarDimensions: WebinarDimensions = {
  isMeasured: false,

  windowArea,
  webinarArea: windowArea,
  videoControlsArea,

  roomArea,
  videoArea,

  video,

  videoStage: {
    radius: 0,
    scale: 1,
    width: videoArea.width,
    height: videoArea.width / video.aspectRatio,
    unscaled: {
      width: videoArea.width,
      height: videoArea.height,
    },
  },

  actionsPane,

  chat: {
    widthRem: 25,
    heightPx: 58,
    paddingLeftRem: 0,
    paddingBottomRem: isMobile ? 0.5 : 1,
  },
};
